import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

export default function RetiredChiefJudges() {
  const [searchParams] = useSearchParams();
  const [textSize, setTextSize] = useState("normal");
  const [judges, setJudges] = useState([]);
  const [category, setCategory] = useState("Retired Chief Judges");
  const [loading, setLoading] = useState(false);
  const _judges = [
    {
      sno: "1",
      name: "Hon. Justice John Idowu Conrad Taylor",
      time: "Jul 22, 1964 - Nov 07, 1973",
    },
    {
      sno: "2",
      name: "Hon. Justice Joseph Adetunji Adefarasin (Decd.)",
      time: "Nov 01, 1974 - Apr 24, 1985",
    },
    {
      sno: "3",
      name: "Hon. Justice Candide Ademola Johnson (Decd.)",
      time: "Apr 25, 1985 - Jul 01, 1989",
    },
    {
      sno: "4",
      name: "Hon. Justice Ligali Akanni Ayorinde (Decd.)",
      time: "Jul 01, 1989 - Apr 10, 1995",
    },
    {
      sno: "5",
      name: "Hon. Justice Roseline Ajoke Omotoso (Mrs.) (Decd.)",
      time: "Apr 12, 1995 - Feb 27, 1996",
    },
    {
      sno: "6",
      name: "Hon. Justice Olusola Olatunde Thomas (Decd.)",
      time: "Mar 15, 1996 - Nov 01, 1996",
    },
    {
      sno: "7",
      name: "Hon. Justice Samuel Omotunde Ilori",
      time: "Dec 27, 1996 - Jan 05, 1999",
    },
    {
      sno: "8",
      name: "Hon. Justice Sikiru Olatunde Adagun",
      time: "May 03, 1999 - May 22, 1999",
    },
    {
      sno: "9",
      name: "Hon. Justice Christopher Olatunde Segun",
      time: "May 24, 1999 - May 25, 2011",
    },
    {
      sno: "10",
      name: "Hon. Justice Ibitola Adebisi Sotuminu O. O. N.",
      time: "May 28, 2001 - May 05, 2004",
    },
    {
      sno: "11",
      name: "Hon. Justice Afolabi Fatai Adeyinka",
      time: "Mar 08, 2004 - Jul 02, 2004",
    },
    {
      sno: "12",
      name: "Hon. Justice Augustine Adetula Alabi O.F.R.",
      time: "Jul 08, 2004 - Aug 07, 2009",
    },
    {
      sno: "13",
      name: "Hon. Justice Inumidun Enitan Akande (Mrs.), O.F.R.",
      time: "Sep 08, 2009 - Jun 10, 2012",
    },
    {
      sno: "14",
      name: "Hon Justice A.A Phillips",
      time: "Jun 14, 2012 - Jul 26, 2014",
    },
    {
      sno: "15",
      name: "Hon Justice F.O Atilade",
      time: "Aug 20, 2014 - Sep 22, 2017",
    },
    {
      sno: "16",
      name: "Hon. Justice Opeyemi Oke",
      time: "Oct 20, 2017 - Jun 10, 2019",
    },
  ];

  useEffect(() => {
    onLoadTeam();
  }, []);
  const onLoadTeam = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/team/${category}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setJudges(data.items);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader />
      {/* Hero Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        <div className="absolute inset-0 bg-black/5 dark:bg-black/30"></div>

        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900 dark:text-white">
              <div>Retired Hon. Chief Judges of</div>
              <small>High Court of Lagos State</small>
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <Accordion type="single" collapsible defaultValue="item-1">
            <AccordionItem value="item-1">
              <AccordionTrigger className="text-xl font-bold">
                Retired Chief Judges List
              </AccordionTrigger>

              <AccordionContent>
                <Card className="mt-6 border-0 shadow-lg">
                  <CardContent className="p-6">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>S/No</TableHead>
                          <TableHead>Name</TableHead>
                          <TableHead>Timeline</TableHead>
                        </TableRow>
                      </TableHeader>

                      <TableBody>
                        {judges.map((judge, i) => (
                          <TableRow key={i}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{judge.fullName}</TableCell>
                            <TableCell>{judge.timeframe}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </section>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
